/* === LT: Inkybay nur auf /pages/personalisiert laden === */
(() => {
  const isPersonalisiert =
    location.pathname === "/pages/personalisiert" ||
    location.pathname.startsWith("/pages/personalisiert/");

  if (!isPersonalisiert) return;

  // Doppelladung verhindern
  if (document.querySelector('script[data-lt-inkybay="1"]')) return;

  const INKYBAY_APP_JS =
    "https://cdn.shopify.com/extensions/bcac563e-b1fd-4f70-8a4e-d90c7bcd4db3/inkybay-product-personalizer-4/assets/app.js";

  const s = document.createElement("script");
  s.src = INKYBAY_APP_JS;
  s.async = true;
  s.setAttribute("data-lt-inkybay", "1");
  document.head.appendChild(s);
})();
/**
 * === LT CUSTOM (update-sicher ausgelagert) ===
 * Live Savings unter dem ATC-Button für Discounty-Staffelpreise.
 * Hinweis: Discounty rechnet im Cart häufig mit Stückpreis-Rundung -> wir runden pro Stück (2 Nachkommastellen),
 * damit die Gesamtsumme besser zum Warenkorb passt.
 */

(() => {
  const WIDGET = ".discounty-volume-discount-widget";
const QTY_INPUT_SELECTOR =
  'input[name="quantity"], .quantity__input, [data-quantity-input]';

  function parseMoneyToNumber(text) {
    if (!text) return null;
    const cleaned = String(text)
      .replace(/\s/g, "")
      .replace(/[^\d.,-]/g, "")
      .replace(/\.(?=\d{3}(\D|$))/g, "")
      .replace(/,/g, ".");
    const num = Number(cleaned);
    return Number.isFinite(num) ? num : null;
  }

  function formatEUR(amount) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  }

  function round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100;
  }

  function getQtyInput() {
    return document.querySelector(QTY_INPUT_SELECTOR);
  }

  function getQty() {
    const input = getQtyInput();
    if (!input) return 1;
    const n = parseInt(input.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function getUnitPriceNumber() {
    const selectors = [
      ".price__current",
      ".price-item--sale",
      ".price-item--regular",
      ".product__price",
      ".price",
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (!el) continue;
      const val = parseMoneyToNumber((el.textContent || "").trim());
      if (val) return val;
    }
    return null;
  }

  function getTiers() {
    const widget = document.querySelector(WIDGET);
    if (!widget) return [];

    const rows = widget.querySelectorAll("tbody tr");
    const tiers = [];

    rows.forEach((tr) => {
      const qtyText =
        tr
          .querySelector(".discounty-volume-discount-widget__criteria")
          ?.textContent?.trim() || "";
      const discText =
        tr
          .querySelector(".discounty-volume-discount-widget__discount")
          ?.textContent?.trim() || "";

      const minQty = parseInt(qtyText.replace("+", "").trim(), 10);
      const m = discText.match(/(\d+)\s*%/);
      if (Number.isFinite(minQty) && m)
        tiers.push({ minQty, percent: parseInt(m[1], 10) });
    });

    tiers.sort((a, b) => a.minQty - b.minQty);
    return tiers;
  }

  function getActivePercent(qty, tiers) {
    let p = 0;
    for (const t of tiers) if (qty >= t.minQty) p = t.percent;
    return p;
  }

  function ensureBox() {
    let box = document.getElementById("live-savings");
    if (box) return box;

    const widget = document.querySelector(WIDGET);

    box = document.createElement("div");
    box.id = "live-savings";
    box.style.display = "none";

    // Prefer: directly after Discounty widget
    if (widget && widget.parentElement) {
      widget.parentElement.insertBefore(box, widget.nextSibling);
      return box;
    }

    // Fallback: after add-to-cart button
    const anchor =
      document.querySelector('button[type="submit"][name="add"]') ||
      document.querySelector(".product-form__submit") ||
      document.querySelector('button[name="add"]');

    if (anchor && anchor.parentElement)
      anchor.parentElement.insertBefore(box, anchor.nextSibling);
    else document.body.appendChild(box);

    return box;
  }

  function update() {
    const widget = document.querySelector(WIDGET);
    if (!widget) return;

    const tiers = getTiers();
    const qty = getQty();
    const unit = getUnitPriceNumber();
    const box = ensureBox();

    if (!unit || tiers.length === 0) {
      box.style.display = "none";
      return;
    }

    const percent = getActivePercent(qty, tiers);

    // Next tier hint
    let nextTier = null;
    for (const t of tiers) {
      if (qty < t.minQty) {
        nextTier = t;
        break;
      }
    }

    const totalList = unit * qty;

    // Rabattierter Stückpreis (auf 2 Stellen gerundet) * qty
    const discountedUnit = round2(unit * (1 - percent / 100));
    const totalDiscounted = round2(discountedUnit * qty);
    const savings = round2(totalList - totalDiscounted);

    box.style.display = "block";

    // Messaging
    const unitLine =
      percent > 0
        ? `Aktuell: <strong>${formatEUR(discountedUnit)}</strong> / Stück (statt ${formatEUR(
            unit
          )})`
        : `Aktuell: <strong>${formatEUR(unit)}</strong> / Stück`;

    const savingsLine =
      percent > 0
        ? `Du sparst: <strong>${formatEUR(savings)}</strong> (${percent}%)`
        : nextTier
        ? `Nächste Stufe: <strong>${nextTier.percent}%</strong> ab <strong>${nextTier.minQty}+</strong> (noch ${
            nextTier.minQty - qty
          } Stück)`
        : `Mengenrabatt aktivierbar`;

    const totalLine =
      percent > 0
        ? `Gesamt: <strong>${formatEUR(totalDiscounted)}</strong>`
        : `Gesamt: <strong>${formatEUR(totalList)}</strong>`;

    box.innerHTML = `
      <div class="lt-volume-savings__inner">
        <div class="lt-volume-savings__line">${savingsLine}</div>
        <div class="lt-volume-savings__sub">${unitLine}</div>
        <div class="lt-volume-savings__sub">${totalLine}</div>
      </div>
    `;
  }

  function bind() {
    const input = getQtyInput();
    if (!input) return;

    input.addEventListener("input", update);
    input.addEventListener("change", update);

    const qtyWrap = input.closest(".quantity");
    if (qtyWrap) {
      qtyWrap.addEventListener("click", (e) => {
        const btn = e.target.closest("button");
        if (!btn) return;
        setTimeout(update, 0);
      });
    }

    update();
  }

  document.addEventListener("DOMContentLoaded", () => {
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;

    // Diese Funktionen existieren in deinem Live-Savings Script
    try { bind(); } catch (e) {}
    try { update(); } catch (e) {}

    const hasWidget = document.querySelector(".discounty-volume-discount-widget");
    const hasQty =
      document.querySelector('input[name="quantity"]') ||
      document.querySelector('.quantity__input') ||
      document.querySelector('[data-quantity-input]');

    // Abbrechen, sobald beides da ist (oder spätestens nach 10 Sekunden)
    if ((hasWidget && hasQty) || tries >= 20) clearInterval(timer);
  }, 500);
});
})();
